<div class="modal-box campaign-analysis-modal" cdkDrag>
    <div class="modal-header campaign-analysis-modal__header" cdkDragHandle>
        <div class="campaign-analysis-modal__headline modal-headline">
            <span class="campaign-analysis-modal__eyebrow modal-eyebrow">{{ 'AI_ANALYSIS' | translate }}</span>
            <h4 class="modal-title campaign-analysis-modal__title modal-heading">{{ 'CAMPAIGN_PERFORMANCE_ANALYSIS' | translate }}</h4>
        </div>
        <button type="button" class="campaign-analysis-modal__close modal-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body campaign-analysis-modal__body">
        <div class="campaign-analysis-modal__sections modal-sections">
            <section class="campaign-analysis-modal__panel campaign-analysis-modal__panel--main modal-panel">
                <div class="campaign-analysis-modal__panel-header modal-panel-header">
                    <span class="campaign-analysis-modal__panel-eyebrow modal-panel-eyebrow">{{ 'CAMPAIGN_PERFORMANCE_SUMMARY' | translate }}</span>
                </div>

                <div *ngIf="!campaignAnalysisLoading && !campaignAnalysis" class="campaign-analysis-modal__empty-state">
                    <p class="campaign-analysis-modal__lead">
                        <ng-container *ngIf="hasAnalysisDateRange; else clickToAnalyzeLast30Days">
                            {{ 'CLICK_TO_ANALYZE_DATE_RANGE' | translate:{ dateStart: dateStart, dateStop: dateStop } }}
                        </ng-container>
                        <ng-template #clickToAnalyzeLast30Days>{{ 'CLICK_TO_ANALYZE' | translate }}</ng-template>
                    </p>

                    <div class="campaign-analysis-modal__status-card">
                        <div *ngIf="metricsLoading" class="campaign-analysis-modal__status-line">
                            <ng-container *ngIf="hasAnalysisDateRange; else loadingLast30Days">
                                {{ 'DATE_RANGE' | translate }} {{ analysisDateRange }}
                            </ng-container>
                            <ng-template #loadingLast30Days>{{ 'LOADING_LAST_30_DAYS_METRICS' | translate }}</ng-template>
                        </div>
                        <div *ngIf="!metricsLoading && metrics" class="campaign-analysis-modal__status-line">
                            <ng-container *ngIf="hasAnalysisDateRange; else usingLast30Days">
                                {{ 'DATE_RANGE' | translate }} {{ metrics.dateStart }} → {{ metrics.dateStop }}
                            </ng-container>
                            <ng-template #usingLast30Days>{{ 'USING_LAST_30_DAYS_METRICS' | translate:{ dateStart: metrics.dateStart, dateStop: metrics.dateStop } }}</ng-template>
                        </div>
                        <div *ngIf="!metricsLoading && !metrics && metricsError" class="campaign-analysis-modal__status-line campaign-analysis-modal__status-line--warning">{{ metricsError }}</div>
                    </div>

                    <button class="blue-button campaign-analysis-modal__button modal-button" (click)="generateCampaignAnalysis()" [disabled]="campaignAnalysisLoading">
                        {{ 'ANALYZE_PERFORMANCE_BUTTON' | translate }}
                    </button>
                </div>

                <div *ngIf="campaignAnalysisLoading" class="campaign-analysis-modal__loading-state">
                    <div class="spinner-border campaign-analysis-modal__spinner" role="status">
                        <span class="visually-hidden">{{ 'LOADING_DOTS' | translate }}</span>
                    </div>
                    <p class="campaign-analysis-modal__lead">{{ 'ANALYZING_PERFORMANCE' | translate }}</p>
                    <p class="campaign-analysis-modal__status-line">
                        <ng-container *ngIf="hasAnalysisDateRange; else compilingLast30Days">
                            {{ 'DATE_RANGE' | translate }} {{ analysisDateRange }}
                        </ng-container>
                        <ng-template #compilingLast30Days>{{ 'COMPILING_RECENT_NOTES_AND_THE_LATEST_30_DAY_METRICS' | translate }}</ng-template>
                    </p>
                </div>

                <div *ngIf="campaignAnalysis" class="campaign-analysis-result campaign-analysis-modal__result">
                    <div class="campaign-analysis-modal__result-toolbar modal-actions">
                        <div>
                            <div class="campaign-analysis-modal__section-label">
                                <ng-container *ngIf="hasAnalysisDateRange; else analysisLast30Days">
                                    {{ 'DATE_RANGE' | translate }} {{ analysisDateRange }}
                                </ng-container>
                                <ng-template #analysisLast30Days>{{ 'LAST_30_DAYS' | translate }}</ng-template>
                            </div>
                            <h4 class="campaign-analysis-modal__result-title">{{ 'LATEST_GENERATED_ANALYSIS' | translate }}</h4>
                        </div>
                        <button *ngIf="!campaignAnalysisSimplified" class="campaign-analysis-modal__refresh-button modal-button" (click)="simplifyCampaignAnalysis()" [disabled]="campaignAnalysisSimplifying">
                            {{ campaignAnalysisSimplifying ? ('SIMPLIFYING_ANALYSIS' | translate) : ('SIMPLIFY_ANALYSIS' | translate) }}
                        </button>
                    </div>

                    <div class="analysis-content campaign-analysis-modal__analysis-content" [innerHTML]="campaignAnalysis"></div>
                </div>
            </section>

            <section class="campaign-analysis-modal__panel campaign-analysis-modal__panel--supporting modal-panel">
                <div class="campaign-analysis-modal__panel-header modal-panel-header">
                    <span class="campaign-analysis-modal__panel-eyebrow modal-panel-eyebrow">{{ 'SOURCE_DATA_AND_TIMING' | translate }}</span>
                </div>

                <div class="campaign-analysis-modal__info-stack modal-stack">
                    <div class="campaign-analysis-modal__info-card">
                        <div class="campaign-analysis-modal__section-label">{{ 'ANALYSIS_BASIS' | translate }}</div>
                        <div class="campaign-analysis-modal__info-copy campaign-analysis-modal__info-copy--inline">
                            <i-feather name="info" class="campaign-analysis-modal__info-icon"></i-feather>
                            <ng-container *ngIf="hasAnalysisDateRange; else analysisBasedOnLast30Days">
                                {{ 'ANALYSIS_BASED_ON_DATE_RANGE' | translate:{ dateStart: dateStart, dateStop: dateStop } }}
                            </ng-container>
                            <ng-template #analysisBasedOnLast30Days>{{ 'ANALYSIS_BASED_ON' | translate }}</ng-template>
                        </div>
                    </div>

                    <div class="campaign-analysis-modal__info-card">
                        <div class="campaign-analysis-modal__section-label">{{ 'METRICS_WINDOW' | translate }}</div>
                        <div *ngIf="metrics" class="campaign-analysis-modal__info-copy">{{ metrics.dateStart }} → {{ metrics.dateStop }}</div>
                        <div *ngIf="!metrics && !metricsLoading" class="campaign-analysis-modal__info-copy">
                            <ng-container *ngIf="hasAnalysisDateRange; else metricsLast30DaysWhenAvailable">
                                {{ 'DATE_RANGE' | translate }} {{ analysisDateRange }}
                            </ng-container>
                            <ng-template #metricsLast30DaysWhenAvailable>{{ 'LAST_30_DAYS_WHEN_AVAILABLE' | translate }}</ng-template>
                        </div>
                        <div *ngIf="metricsLoading" class="campaign-analysis-modal__info-copy">{{ 'PREPARING_DATE_RANGE_AND_OVERVIEW_METRICS' | translate }}</div>
                    </div>

                    <div class="campaign-analysis-modal__info-card" *ngIf="metricsError">
                        <div class="campaign-analysis-modal__section-label">{{ 'METRICS_STATUS' | translate }}</div>
                        <div class="campaign-analysis-modal__info-copy campaign-analysis-modal__info-copy--warning">{{ metricsError }}</div>
                    </div>
                    <div class="campaign-analysis-modal__info-card" *ngIf="notesError">
                        <div class="campaign-analysis-modal__section-label">{{ 'NOTES_STATUS' | translate }}</div>
                        <div class="campaign-analysis-modal__info-copy campaign-analysis-modal__info-copy--warning">{{ notesError }}</div>
                    </div>
                </div>
            </section>
        </div>

        <section *ngIf="isAdmin" class="campaign-analysis-modal__admin-editor modal-panel">
            <div class="campaign-analysis-modal__panel-header modal-panel-header">
                <span class="campaign-analysis-modal__panel-eyebrow modal-panel-eyebrow">Admin Prompt Editor</span>
            </div>
            <div class="campaign-analysis-modal__admin-fields">
                <label class="campaign-analysis-modal__field">
                    <span class="campaign-analysis-modal__section-label">Prompt</span>
                    <textarea class="form-control" rows="12" [(ngModel)]="adminPrompt"></textarea>
                </label>
                <label class="campaign-analysis-modal__field">
                    <span class="campaign-analysis-modal__section-label">Metrics</span>
                    <textarea class="form-control" rows="8" [(ngModel)]="adminMetricsBlock"></textarea>
                </label>
                <label class="campaign-analysis-modal__field">
                    <span class="campaign-analysis-modal__section-label">Notes</span>
                    <textarea class="form-control" rows="8" [(ngModel)]="adminNotesBlock"></textarea>
                </label>
                <label class="campaign-analysis-modal__field">
                    <span class="campaign-analysis-modal__section-label">System Content (Instructions)</span>
                    <textarea class="form-control" rows="8" [(ngModel)]="adminSystemContent"></textarea>
                </label>
                <label class="campaign-analysis-modal__field">
                    <span class="campaign-analysis-modal__section-label">Temperature (How much freedom to give the AI to respond - higher number = more freedom and less structured results)</span>
                    <input class="form-control" type="number" min="0" max="1.4" step="0.1" [(ngModel)]="adminTemperature" />
                </label>
                <label class="campaign-analysis-modal__field">
                    <span class="campaign-analysis-modal__section-label">Model</span>
                    <select class="form-control" [(ngModel)]="adminModel">
                        <option value="gpt-5-mini">GPT-5 mini</option>
                        <option value="gpt-5">GPT-5</option>
                        <option value="gpt-5.6-luna">GPT-5.6 Luna (default)</option>
                        <option value="gpt-5.6-terra">GPT-5.6 Terra</option>
                    </select>
                </label>
            </div>
            <button type="button" class="blue-button campaign-analysis-modal__button modal-button" (click)="resendAdminCampaignAnalysis()" [disabled]="campaignAnalysisLoading">
                Resend Analysis
            </button>
        </section>
    </div>

    <div class="modal-footer campaign-analysis-modal__footer" cdkDragHandle>
        <div class="campaign-analysis-modal__actions modal-actions">
            <button type="button" class="red-outline-button campaign-analysis-modal__button modal-button" (click)="activeModal.close()">{{ 'CLOSE' | translate }}</button>
        </div>
    </div>
</div>
